import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function OpenRoute({ children }) {
  const { token, onBoarding } = useSelector((state) => state.auth);
  const user = useSelector((state) => state.profile.user);

  if (!token) {
    return children;
  }

  if (token && onBoarding) {
    return <Navigate to="/onboarding" replace />;
  }

  if (token && user) {
    return <Navigate to="/vendor-dashboard" replace />;
  }

  return children;
}

export default OpenRoute;
